import { Container, Box, Link, TextField, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import React, { useState, useMemo } from 'react';
import { useIntl } from 'react-intl';

import { IBrands } from 'api/catalog/models';
import { ComputedRoute } from 'utils/ComputedRoute';
import ColumnView from 'ui/ColumnView';
import { useColumnView, useDebounce, useQueryString } from 'hooks';
import { toTitleCase } from 'utils/toTitleCase';

import messages from './messages';

interface IProps {
  brands: IBrands;
}

const BrandListing = ({ brands }: IProps) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearch = useDebounce(searchTerm, 500);
  const filteredItems = useMemo(
    () =>
      brands.brands.filter((brand) =>
        brand.name.toLowerCase().includes(debouncedSearch.toLowerCase())
      ),
    [brands.brands, debouncedSearch]
  );
  const items = useColumnView(filteredItems);
  const { parsedQueryString } = useQueryString();
  const { brandRegex, ...rest } = parsedQueryString;

  return (
    <Container maxWidth='xl'>
      <Box
        sx={{
          backgroundColor: theme.palette.grey[200],
          padding: '25px',
          marginBottom: '15px',
        }}
      >
        <TextField
          sx={{ backgroundColor: theme.palette.common.white }}
          fullWidth
          id='outlined-basic'
          label={formatMessage(messages.searchPlaceholder)}
          variant='outlined'
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value || '')}
        />
      </Box>
      <ColumnView>
        {items.map((group, index) => (
          <Box key={index}>
            <ul style={{ margin: '0px', padding: '0px 0px 0px 20px' }}>
              {group.map((item) => (
                <li
                  style={{ color: theme.palette.primary.main }}
                  key={item.name}
                >
                  <Link
                    sx={{ display: 'block' }}
                    key={item.name}
                    component={RouterLink}
                    to={ComputedRoute.getSearchRoute({
                      brandNames: [item.name],
                      ...rest,
                    })}
                  >
                    {toTitleCase(item.name)}
                  </Link>
                </li>
              ))}
            </ul>
          </Box>
        ))}
      </ColumnView>
    </Container>
  );
};

export default BrandListing;
